<template>
    <el-container style="min-height: 100%;">
      <!--初始化文章的富文本编辑器,第二次访问的时候可以加速-->
      <tinymce-editor style="display: none"/>
      <el-header style="position:fixed;z-index:10;width:100%;height:69px; background-image: url('static/images/header.png');">
      <Header/>
      </el-header>
      <main style="background-color: #eef5fc;margin-top: 69px;">
        <router-view/>
      </main>

    </el-container>
</template>

<script>
import Header from "./header";
import Main from "./Main";
import TinymceEditor from "../../components/tinymce/TinymceEditor";
export default {
  name: 'home',
  components:{TinymceEditor, Header,Main},
  props: {
    msg: String
  },
  data(){
   return{
     iconDirection:'iconDirectionLeft',
     deptPower: false,
     superPower: false,
   }
  },
  mounted() {
    this.getAuth()
  },
  methods:{
    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.deptPower = this.$store.state.userPowerStore.deptPower
        this.superPower = this.$store.state.userPowerStore.superPower
      })
    },
  }
 }
</script>



// WEBPACK FOOTER //
// src/pages/home/home.vue